import { JSX } from "react";
import Button from "./Common/Button";

interface HeaderProps {
  userImage: string;
  onSignOut: () => void;
  onSeeInstructions: () => void;
}

const Header = ({ userImage, onSignOut, onSeeInstructions }: HeaderProps): JSX.Element => {
  return (
    <div className="top-0 z-10 sticky bg-gray-100 shadow-md w-full">
      <div className="flex justify-between items-center bg-white shadow px-3 md:px-4 py-2 md:py-3">
        <div className="items-center gap-2 grid grid-cols-[auto_1fr]">
          <div className="relative">
            <img
              src="/images/logo-small.svg"
              alt="Logo"
              className="md:hidden w-full max-w-[100px]"
            />
            <img
              src="/images/logo.svg"
              alt="Logo"
              className="hidden md:block w-full max-w-[144px]"
            />
          </div>
          <div className="w-full text-textDefault md:text-[20px] text-base uppercase tracking-widest">
            Signature Details
          </div>
        </div>
        <div className="flex items-center gap-2 md:gap-3">
          <Button
            variant="outline"
            onClick={onSeeInstructions}
            className="flex items-center gap-1.5 p-2 md:px-4 md:py-2"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span className="hidden md:inline">See Instructions</span>
          </Button>
          <Button variant="ghost" onClick={onSignOut} className="flex items-center gap-2">
            <span className="hidden md:inline">Sign Out</span>
            <img src={userImage} alt="User" className="rounded-full w-7 md:w-8 h-7 md:h-8" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Header;
